export const postScheduleInitialState = {
	schedules: null,
	error: null,
	errorShow: false,
	loading: false,
};
